import { AppState } from '../../types';

export const selectCurrentOrganizationTab = (state: AppState): string => state.tabs.organizationTab;

export const selectCurrentProjectTab = (state: AppState): string => state.tabs.projectTab;

export const selectCurrentProfileTab = (state: AppState): string => state.tabs.profileTab;

export const selectCurrentOwnOrganizationTab = (state: AppState): string => state.tabs.ownOrganizationTab;

export const selectCurrentVideoMenuTab = (state: AppState): string => state.tabs.videoMenuTab;

export const selectCurrentUserTab = (state: AppState): string => state.tabs.userTab;
